<template>
  <div class="add-member-modal fdyModal" v-if="isNeedRrefresh">
    <el-dialog
      :visible.sync="addModalVisible"
      width="932px"
      :before-close="handleClose"
      :close-on-click-modal="closeonclickmodal"
    >
      <div slot="title" class="member-modal-title">
        <span class="modal-title-span">新增公众号（不含服务号）</span>
      </div>
      <div class="member-modal-content">
        <div class="third-rea">
          <div class="third-btn">
            <div class="btn-left">检索条件</div>
            <div class="btn-right">
              <el-button class="btn-two" type="primary" @click="searchInput"
                >查询</el-button
              >
              <el-button class="btn-two" type="default" @click="resetInput"
                >重置</el-button
              >
            </div>
          </div>
          <div class="third-search" style="padding-bottom: 0">
            <el-form
              :inline="true"
              :model="addData"
              label-width="76px"
              @keyup.native.enter="searchInput"
            >
              <div class="search-row">
                <div class="row-item member-search-item">
                  <el-form-item label="公众号名称">
                    <el-input
                      :maxlength="30"
                      class="item-input"
                      v-model="serviceName"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="row-item member-search-item">
                  <el-form-item label="公众号性质">
                    <el-select
                      class="item-input"
                      v-model="mpType"
                      placeholder="请选择"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option :value="4" label="部门号"></el-option>
                      <el-option :value="5" label="订阅号"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="third-one">
          <el-table
            ref="addMemberTable"
            class="third-tableThree tableThree-add"
            :data="tableData"
            @select="handleSelection"
            @select-all="selectAllBox"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column type="selection" width="32px"></el-table-column>
            <el-table-column
              prop="serviceName"
              label="公众号名称"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="accountSubject"
              label="账号主体"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="mpType"
              label="公众号性质"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <span>{{ row.mpType === "4" ? "部门号" : "订阅号" }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="third-page add-modal-page">
            <div class="page-left">
              <span class="left-data"
                >已选中{{ selectedList.length }}条数据</span
              >
            </div>
            <el-pagination
              class="page-right"
              @size-change="addSizeChange"
              @current-change="addCurrentChange"
              :current-page="addPage"
              background
              :page-sizes="[10, 20, 30, 40]"
              :page-size="addPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="stuAddTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="member-modal-footer">
        <el-button class="modal-footer-two" @click="closeModal">取消</el-button>
        <el-button
          class="modal-footer-two"
          type="primary"
          @click="agreeAdd"
          v-el-disabel-repeat-click
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getMpListPort } from '@/api/appSetting/appServiceSetting'
// import { selectJZG, FenpeiFDY } from "@/api/baseData/banji";

export default {
  name: "addMemberModal",
  props: {
    addData: {
      type: Object
    },
    addItem: {
      type: Object
    },
    addColumn: {
      type: Array
    },
    addModalVisible: {
      type: Boolean,
      default: false
    },
    addModalTitle: {
      type: String,
      default: "添加人员（不含已有人员）"
    },
    addType: {
      type: String,
      default: "1"
    },
    // ClassList: {//去除
    //   type: Array
    // },
    //是否点击空白处关闭弹窗
    closeonclickmodal: {
      type: Boolean,
      default: false
    },
    //客户当前ID
    NowCustomerId: {
      type: String
    },
    choosedList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    choosedList () {
      this.cpChoosedList = this.choosedList
    },
    addModalVisible (val) {
      // console.log(val)
      // console.log(this.addType)
      if (val) {
        if (this.cpChoosedList) {
          this.selectedList = this.cpChoosedList
        }
        this.resetSearch = false;
        this.getMpList();
      } else {
        this.refreshDialog()
        this.resetSearch = true;
      }
      // console.log(this.addColumn)
    },
    tableData () {
      console.log('this.selectedList', this.selectedList)
      if (this.selectedList.length) {
        this.selectedList.forEach(el => {
          const tableData = this.tableData
          const choosedDataIndex = tableData.findIndex(choosedData => {
            return choosedData.serviceId === el.serviceId
          })
          if (choosedDataIndex !== -1) {
            // this.$refs.multipleTable.toggleRowSelection(row);
            this.$nextTick(() => {
              console.log('choosedDataIndex', choosedDataIndex)
              this.$refs.addMemberTable.toggleRowSelection(tableData[choosedDataIndex], true)
            })
          }
        })
      }
    }
  },
  created () { },
  data () {
    return {
      cpChoosedList: this.choosedList,
      isNeedRrefresh: true,
      mpType: '',
      serviceName: '',
      loading: false,
      onlyId: "id", // 添加人员列表的唯一标识
      // onlyId: "teacherId", // 添加人员列表的唯一标识
      addPage: 1, // 页码
      addPageSize: 10, // 条数
      stuAddTotal: 0, // 总数
      tableData: [], // 添加弹窗表格
      selectArr: [], // 排除的选中项/或当前选中项，根据是否全选决定,
      allSelect: false, // 是否全选
      resetSearch: false, // 重置搜索选择项
      selectCount: 0, // 选中多少条
      fixCount: 0, // 不随搜索条件改变的列表总数
      selectedList: []
    };
  },
  methods: {
    refreshDialog () {
      this.isNeedRrefresh = false
      this.$nextTick(() => {
        this.isNeedRrefresh = true
      })
    },
    async getMpList () {
      this.tableData = []
      const {
        data: {
          result, msg, status
        }
      } = await getMpListPort(
        {
          serviceName: this.serviceName,
          mpType: this.mpType,
          pageIndex: this.addPage,
          pageSize: this.addPageSize
        }
      )
      if (status === 1000) {
        this.tableData = result.dataList
        this.stuAddTotal = result.total
        return
      }
      return this.$message.error(msg)
    },
    // 重置方法
    resetFormData () {
      // console.log(this.addData)
      this.$nextTick(async () => {
        this.addPage = 1;
        await this.getMpList();
      });
    },
    // 搜索
    async searchInput () {
      this.addPage = 1;
      await this.getMpList();
    },
    // 重置
    resetInput () {
      this.addPage = 1;
      this.serviceName = ''
      this.mpType = ''
      this.getMpList();
    },
    // 选中全部
    selectAllBox (val) {
      console.log(val)
      this.selectedList = val
    },
    // 选中项
    handleSelection (selection, val) {
      console.log('selection', selection, val)
      this.selectedList = selection
    },
    // 选中全部
    selectAll () { },
    // 取消选中全部
    cancelAll () { },
    // 条数变化
    async addSizeChange (val) {
      this.addPage = 1;
      this.addPageSize = val;
      await this.getMpList();
    },
    // 页码变化
    async addCurrentChange (val) {
      this.addPage = val;
      await this.getMpList();
    },
    // 弹窗关闭触发
    handleClose () {
      this.selectCount = 0;
      this.allSelect = false;
      this.selectArr = [];
      this.addPage = 1;
      this.$emit("closeAddModal");
    },
    // 确认
    agreeAdd () {
      if (this.selectedList.length === 0) {
        return this.$message.warning("请选择需要新增的公众号");
      }
      if(this.selectedList.length > 9 ) {
        return this.$message.warning("最多只能增加9个公众栏目");
      }
      this.$emit('addData', this.selectedList)
    },
    // 取消
    closeModal () {
      this.$emit("closeAddModal");
    },
  }
};
</script>

<style lang="scss">
.add-member-modal {
  .el-dialog__header {
    border-bottom: 1px solid #d4d4d7;
    padding: 11px 16px;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .member-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        color: #2e4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 500px;
    padding: 8px;
    overflow-y: auto;
    .member-modal-content {
      .member-search-item {
        width: 300px !important;
        text-align: right !important;
        padding-bottom: 8px;
      }
      .tableThree-add {
        .el-table__body-wrapper {
          height: 280px;
        }
      }
      .add-modal-page {
        font-size: 0;
        .page-left {
          display: inline-block;
          width: 245px;
          text-align: left;
          vertical-align: top;
          .el-button {
            height: 24px;
          }
          .btn-one {
            margin-left: 0 !important;
          }
          .left-data {
            padding-left: 8px;
            color: #2e4057;
            font-size: 12px;
          }
        }
        .page-right {
          padding-top: 4px;
          display: inline-block;
          width: calc(100% - 245px);
          padding-right: 0;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #d4d4d7;
    padding: 16px;
    .member-modal-footer {
      font-size: 0;
      .el-button {
        margin-left: 8px !important;
      }
      .modal-footer-two {
        height: 28px;
      }
    }
  }
}
</style>
